export const getMiles = (meters: number) => {
  return (meters * 0.000621371192).toFixed(0);
};

export const getFeet = (meters: number) => {
  return (meters * 3.28084).toFixed(0);
};
